const DICTIONARIES = {
  en: {
    driver: 'Driver',
    drivers: 'Drivers',
    license_number: 'Driver License Number',
    license_number_abbr: 'D. License Number',
    license_type: 'Driver License Type',
    license_type_abbr: 'D. License Type',
    name: 'Driver Name',
    phone_number: 'Driver Phone Number',
    phone_number_abbr: 'D. Phone Number',
    replacement_driver: 'Replacement Driver',
    replacement_driver_end_date: 'Replacement Driver End Date',
    replacement_driver_name: 'Replacement Driver Name',
    replacement_driver_start_date: 'Replacement Driver Start Date',
  },
};

export default DICTIONARIES;
